import { Album, Tag, Ticket, User, RefreshCw, FileText } from "lucide-react";

export const NAV_ITEMS = [
  {
    to: "/inventory",
    icon: Ticket,
    label: "Inventory",
  },
  {
    to: "/top-up",
    icon: RefreshCw,
    label: "Top-Up",
  },
  {
    to: "/purchase-ticket",
    icon: Tag,
    label: "Purchase Ticket",
  },
  {
    to: "/topup-history",
    icon: FileText,
    label: "Top-Up History",
  },
  {
    to: "/booking-history",
    icon: Album,
    label: "Booking History",
  },
  {
    to: "/profile",
    icon: User,
    label: "Profile",
  },
] as const;
